import { createFileRoute } from "@tanstack/react-router";

import { orNotFound } from "../components/prenoms/load";
import { YearPage, yearHead } from "../components/prenoms/year-pages";
import { namesApi } from "../lib/api";
import { seo } from "../lib/head";

export const Route = createFileRoute("/prenoms/annee/$year/")({
  staticData: { ssr: true },
  loader: ({ context, params }) =>
    orNotFound(() =>
      context.queryClient.query({
        queryKey: ["prenoms-year", params.year],
        queryFn: () => namesApi.year(params.year),
        staleTime: "static",
      }),
    ),
  head: ({ loaderData }) => (loaderData ? seo(yearHead(loaderData)) : {}),
  component: Page,
});
function Page() {
  return <YearPage data={Route.useLoaderData()} />;
}
